import React from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import ConfirmSubscriptionChangeWindow from '../account/ConfirmSubscriptionChangeWindow'
import Link from '../widgets/Link'
import Currency from '../account/Currency'
import WebsiteQuota from './Quota'
import WebsitePayment from './Payment'

import usePaymentConfirmation from '../hooks/usePaymentConfirmation'

import websiteSelectors from '@nocode-works/template/store/selectors/website'
import stripeSelectors from 'store/selectors/stripe'
import appsumoSelectors from 'store/selectors/appsumo'

const useStyles = makeStyles(theme => ({
  pricingToolbar: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  pricingNote: {
    flexGrow: 0,
  },
  currencies: {
    textAlign: 'right',
    flexGrow: 1,
  },
}))

const WebsitePlan = ({
  
}) => {
  const classes = useStyles()
  const website = useSelector(websiteSelectors.websiteData)
  const changePlanInfoSummary = useSelector(stripeSelectors.changePlanInfoSummary)
  const appsumoPlan = useSelector(appsumoSelectors.activePlan)

  usePaymentConfirmation()

  return (
    <Grid container spacing={ 4 }>
      {
        !appsumoPlan && (
          <Grid item xs={ 12 }>
            <Typography gutterBottom variant="h6">
              Plan
            </Typography>
            <WebsitePayment
              website={ website }
            />
            <div className={ classes.pricingToolbar }>
              <div className={ classes.pricingNote }>
                <Typography variant="caption">
                  Prices shown are per website
                </Typography>
              </div>
              <div className={ classes.currencies }>
                <Link
                  name="account.payments"
                  path="/payments"
                >
                  open payment settings
                </Link>
                <Currency />
              </div>
            </div>
          </Grid>
        )
      }
      <Grid item xs={ 12 }>
        <WebsiteQuota />
      </Grid>
      {
        changePlanInfoSummary && (
          <ConfirmSubscriptionChangeWindow />
        )
      }
    </Grid>
  )
}

export default WebsitePlan